import { useEffect, useRef } from "react";
import { PostVerdictBubble } from "./PostVerdictBubble";
import type { ThreadMessage, Spokesperson } from "@/hooks/use-post-verdict";

interface Props {
  thread: ThreadMessage[];
  spokesperson: Spokesperson;
}

export function PostVerdictThread({ thread, spokesperson }: Props) {
  const endRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    endRef.current?.scrollIntoView?.({ behavior: "smooth", block: "end" });
  }, [thread]);

  return (
    <section
      data-testid="post-verdict-thread"
      data-rp="thread-scroll"
      role="log"
      aria-live="polite"
      aria-relevant="additions text"
      aria-label="Échange avec le porte-parole"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 20,
        marginBottom: 32,
      }}
    >
      {thread.map((m, i) => (
        <PostVerdictBubble key={i} message={m} spokesperson={spokesperson} />
      ))}
      <div ref={endRef} />
    </section>
  );
}

export default PostVerdictThread;
